import { render, staticRenderFns } from "./Balances.vue?vue&type=template&id=94ced02e&scoped=true&"
import script from "./Balances.vue?vue&type=script&lang=js&"
export * from "./Balances.vue?vue&type=script&lang=js&"
import style0 from "./Balances.vue?vue&type=style&index=0&id=94ced02e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ced02e",
  null
  
)

export default component.exports